<template>
    <div class="app-header bg-white border-zinc-500 border-b">
        <layout-contained>
            <div class="flex flex-row space-x-2 items-center py-2 text-2xl">
                <nuxt-link :aria-label="$config.public.siteName" to="/">
                    <picture>
                        <source :srcset="$config.public.images + $config.public.siteLogoAvif" type="image/avif" media />
                        <source :srcset="$config.public.images + $config.public.siteLogoWebp" type="image/webp" media />
                        <img :src="$config.public.images + $config.public.siteLogo" width="103" height="61" alt />
                    </picture>
                </nuxt-link>
                <div class="uppercase font-bold text-base">Tanker Care</div>
            </div>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'AppHeader',
};
</script>
